import { IResidentPhone } from '../../../common/services/residents-service/residents.service.types';

export const getPhoneComparer = () => {
  return (a: IResidentPhone, b: IResidentPhone) => {
    return a.order - b.order;
  };
};
